import { useMemo } from 'react';

import { Box, Link, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';

import { ReactComponent as LogoDarkImg } from 'assets/images/logo-dark.svg';
import { ReactComponent as LogoLightImg } from 'assets/images/logo-light.svg';

const useStyles = makeStyles(({ palette, typography }) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    textDecoration: 'none !important',
  },
  version: {
    userSelect: 'none',
    color: palette.text.secondary,
    fontSize: typography.pxToRem(8),
  },
}));

export default function Logo() {
  const classes = useStyles();
  const { palette } = useTheme();

  const LogoComponent = useMemo(() => {
    return palette.type === 'dark' ? LogoDarkImg : LogoLightImg;
  }, [palette.type]);

  return (
    <Link className={classes.root} component={RouterLink} to="/">
      <Box display="inline-block">
        <LogoComponent width={140} height={32} />
      </Box>
      <Typography className={classes.version} component="span">
        {process.env.REACT_APP_VERSION}
      </Typography>
    </Link>
  );
}
